<template>
  <div class="container-custom">
    <v-form ref="form" @submit.prevent="saveHandler">
      <Breadscrumbs
        :links="[
          {
            name: 'VideoCateCenter',
            to: {
              name: 'VideoCateCenter'
            }
          },
          {
            name: 'Create',
            to: {
              name: 'VideoCateCreate',
            }
          }
        ]"
      ></Breadscrumbs>
      <!-- page-actions -->
      <div class="page-actions">
        <h2>新增分類</h2>
        <v-spacer></v-spacer>
        <button class="btn mr-5" @click="cancelHandler">
          <span>取消</span>
        </button>
        <button class="btn btn-primary" type='submit'>
          <span>儲存</span>
        </button>
      </div>
    </v-form>
    <!-- Block 新增類別 -->
    <VideoCategoryCreateEdit></VideoCategoryCreateEdit>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import Breadscrumbs from '@/components/Breadscrumbs.vue';
import VideoCategoryCreateEdit from '@/views/E-6__SupportVideos/c/VideoCateCreateEdit.vue';

export default {
  components: {
    Breadscrumbs,
    VideoCategoryCreateEdit,
  },
  computed: {
    ...mapState('videocate', ['videocate']),
  },
  created() {
    this.setVideoCate({});
  },
  methods: {
    ...mapActions('videocate', ['setVideoCate', 'save']),
    cancelHandler() {
      this.$router.push({ name: 'VideoCateCenter' });
    },
    saveHandler() {
      this.errors = [];
      if (this.$refs.form.validate()) {
        if (!this.videocate.title) {
          this.errors.push('標題 required.');
        } else if (!this.videocate.bu_id) {
          this.errors.push('BU required.');
        } else if (!this.videocate.support_categories_id) {
          this.errors.push('類別 required.');
        }
        if (this.errors.length > 0) {
          /* eslint-disable */
          alert(this.errors);
          /* eslint-disable */
          return false;
        }
        this.save(this.videocate).then(() => {
          this.$router.push({ name: 'VideoCateCenter' });
        });
      }
    },
  },
};
</script>
<style></style>
